module.exports = "/assets/data/086989f6abb20d410d92a14dacb38e43-WD4.data.json";